import { useContent } from "../../context/ContentContext";
import { assetUrl } from "../../lib/api";

const DEFAULTS = {
  markUrl: "/assets/ifgl-mark.png",
  logotype: "IFGL",
  copy: "© 2026 IFGL — Indian Fashion Glamour League",
  statusLabel: "Applications Open",
};

const Footer = () => {
  const { content } = useContent();
  const f = { ...DEFAULTS, ...(content?.footer || {}) };

  return (
    <footer
      data-testid="footer"
      className="relative bg-black pt-16 pb-12 px-6 overflow-hidden"
    >
      <p
        aria-hidden
        className="pointer-events-none absolute -bottom-8 md:-bottom-16 left-1/2 -translate-x-1/2 font-condensed font-black leading-none whitespace-nowrap select-none"
        style={{
          fontSize: "clamp(120px, 22vw, 360px)",
          color: "rgba(237, 235, 221, 0.04)",
          letterSpacing: "0.05em",
        }}
      >
        {f.logotype}
      </p>

      <div className="relative max-w-7xl mx-auto">
        <div className="flex items-center justify-center gap-3 mb-12">
          <span className="block w-2 h-2 border border-gold/60 rotate-45" />
          <span className="block h-px w-24 md:w-40 bg-gold/40" />
          <span className="block w-2 h-2 border border-gold rotate-45" />
          <span className="block h-px w-24 md:w-40 bg-gold/40" />
          <span className="block w-2 h-2 border border-gold/60 rotate-45" />
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 text-cotton/55">
          <a
            href="#top"
            data-testid="footer-logotype"
            className="inline-flex items-center gap-3 group"
          >
            {f.markUrl && (
              <img
                src={assetUrl(f.markUrl)}
                alt={f.logotype}
                className="h-10 w-auto opacity-80 transition-opacity duration-300 group-hover:opacity-100"
                draggable="false"
              />
            )}
            <span
              className="font-condensed font-black tracking-[0.18em] text-cotton/70 transition-colors duration-300 group-hover:text-cotton"
              style={{ fontSize: "20px" }}
            >
              {f.logotype}
            </span>
          </a>

          <span
            data-testid="footer-copy"
            className="text-[11px] tracking-[0.35em] uppercase font-light text-center"
          >
            {f.copy}
          </span>

          <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.4em] uppercase font-light text-cotton/45">
            <span className="block w-1.5 h-1.5 bg-red rounded-full" />
            <span>{f.statusLabel}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
